export default __webpack_public_path__ + "static/media/pdf_placeholder.3dfcb5cd.png";